import script from "./PriceCalculatorView.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceCalculatorView.vue?vue&type=script&setup=true&lang=js"

import "./PriceCalculatorView.vue?vue&type=style&index=0&id=58565252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58565252"]])

export default __exports__